export default "__VITE_ASSET__FY1AvkSX__"